var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#746250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,4.02277778 C4.21333333,4.02277778 0.161666667,10.3888889 0.161666667,10.3888889 C0.161666667,10.3888889 3.11305556,16.755 10,16.755 C16.9444444,16.755 19.8383333,10.3888889 19.8383333,10.3888889 C19.8383333,10.3888889 15.8452778,4.02277778 10,4.02277778 Z M10,14.4394444 C7.74305556,14.4394444 5.94944444,12.6458333 5.94944444,10.3888889 C5.94944444,8.13194444 7.74305556,6.33833333 10,6.33833333 C12.2569444,6.33833333 14.0505556,8.13194444 14.0505556,10.3888889 C14.0505556,12.6458333 12.2569444,14.4394444 10,14.4394444 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7361111,10.3888889 C11.7361111,11.3480833 10.9591944,12.125 10,12.125 C9.04080556,12.125 8.26388889,11.3480833 8.26388889,10.3888889 C8.26388889,9.42969444 9.04080556,8.65277778 10,8.65277778 C10.9591944,8.65277778 11.7361111,9.42969444 11.7361111,10.3888889"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.1054ff5948fd09455f3ddb388bd827d1.svg";
export { ForwardRef as ReactComponent };